module.exports = __webpack_public_path__ + "static/img/4.c762b5a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/4.png
// module id = HLI2
// module chunks = 0